import { render, staticRenderFns } from "./QueuePanel.vue?vue&type=template&id=4b96fa3b&scoped=true&lang=pug"
import script from "./QueuePanel.vue?vue&type=script&lang=js"
export * from "./QueuePanel.vue?vue&type=script&lang=js"
import style0 from "./QueuePanel.vue?vue&type=style&index=0&id=4b96fa3b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96fa3b",
  null
  
)

export default component.exports